import {
  GET_FORM_STEPS,
  COMPLIANCE,
  IS_SELF_EMPLOYMENT_VALID,
} from '@/app/business/store/constants';

const REQUIRED_STEPS = [
  {
    number: 1,
    title: 'Overview',
  },
  {
    number: 2,
    title: 'Compliance',
  },
  {
    number: 3,
    title: 'Self Employment',
  },
];

export default {
  // Display different step sequences according to compliance
  [GET_FORM_STEPS]: (state) => {
    const compliance = state[COMPLIANCE];

    if (compliance) {
      return [...REQUIRED_STEPS,
        {
          number: 4,
          title: 'Accounts Receivable',
        },
        {
          number: 5,
          title: 'Accounts',
        },
      ];
    }

    return [...REQUIRED_STEPS];
  },
  // Check required self employment fields
  [IS_SELF_EMPLOYMENT_VALID]: (state) => {
    const requiredFields = [
      'businessEIN',
      'nameOfBusiness',
      'typeOfBusiness',
    ];

    if (requiredFields.some(field => state.selfEmployment[field] === '')) {
      return false;
    }

    return true;
  },
};
